export enum BranchOfficeType {
	PhysicalBranch = 'PhysicalBranch',
	OfficeCashDesk = 'OfficeCashDesk',
	BankAccount = 'BankAccount',
	ExternalPaymentLink = 'ExternalPaymentLink',
	PhysicalPos = 'PhysicalPos',
	TaxCredit = 'TaxCredit',
}

export interface IBranchOfficeTypeWithName {
	id: BranchOfficeType;
	name: string;
}

export const branchOfficeTypeWithNameList: IBranchOfficeTypeWithName[] = [
	{ id: BranchOfficeType.PhysicalBranch, name: 'Sucursal' },
	{ id: BranchOfficeType.OfficeCashDesk, name: 'Caja de Sucursal' },
	{ id: BranchOfficeType.BankAccount, name: 'Cuenta Bancaria' },
	{ id: BranchOfficeType.ExternalPaymentLink, name: 'Link de Pago Externo' },
	{ id: BranchOfficeType.PhysicalPos, name: 'POS Físico' },
	{ id: BranchOfficeType.TaxCredit, name: 'Crédito Fiscal' },
];

export interface IBranchOfficeList {
	id: number;
	name: string;
	branchOfficeType: BranchOfficeType;
	active: boolean;
	phoneNumber?: string;
	email?: string;
}

export interface IBaseBranchOffice {
	id: number;
	name: string;
	branchOfficeType: BranchOfficeType;
	active: boolean;
}

export interface IImage {
	id: number;
	name: string;
	image: string;
}

export enum WeekDayEnum {
	MONDAY = 1,
	TUESDAY,
	WEDNESDAY,
	THURSDAY,
	FRIDAY,
	SATURDAY,
	SUNDAY,
}

export enum EngineEnum {
	BUSES = 1,
	CARS,
	CRUISES,
	FERRY,
	FLIGHTS,
	HOTELS,
	PACKAGES,
	TOURS,
	INSURANCES,
}

export interface IBranchOfficeSchedule {
	id: number;
	weekDay: WeekDayEnum;
	initialTime: string;
	endTime: string;
}

export interface IBranchOfficePhysicalBranch extends IBaseBranchOffice {
	address: string;
	phoneNumber: string;
	lat: number;
	lng: number;
	email: string;
	image: IImage;
	schedules: IBranchOfficeSchedule[];
	engines: EngineEnum[];
}

export interface IBranchOfficeCurrencyConfig {
	currency: string;
	netSuiteAccountId: number;
}

export interface IBranchOfficeNotPhysicalBranch extends IBaseBranchOffice {
	onlyAdmins: boolean;
	currencyConfigs: IBranchOfficeCurrencyConfig[];
}

export interface INetsuiteAccount {
	id: number;
	accountNumber: string;
	accountName: string;
	currency: string; // ISO (ej: "USD", "UYU")
}
